export const FLEET_MANAGER = 'Fleet Manager';
export const FLEET_USER = 'Fleet User';
export const FLEET_SUPPORT = 'Fleet Support';

export const FLEET_ROLES = new Set([FLEET_MANAGER, FLEET_USER, FLEET_SUPPORT]);
